import React, {useEffect, useRef, useState} from 'react';
import './Profile.module.css'
import styles from "./Profile.module.css"
import TextField from "@mui/material/TextField";
import {Label} from "@mui/icons-material";
import {useDispatch} from "react-redux";
import {changeAvatar, deleteAvatar} from "./profileSlice";

const Modal = ({visible, setVisible}) => {
    const fileRef = useRef(null)
    const dispatch = useDispatch()
    const [image, setImage] = useState()
    let formData = new FormData()
    formData.append('avatar', image)
    const handleClick = () => {
        fileRef.current.click()
    }
    const handleChangeImage = () => {
        let formData = new FormData()
        formData.append('avatar', image)
        dispatch(changeAvatar(formData)).then((params) => {
            if (!params.error) {
                setVisible(false)
                window.showAlert({title: 'Аватар успешно изменен', type: 'success'})
            }
            else {
                window.showAlert({title: 'Что то пошло не так', type: 'error'})
            }
        })
    }

    const handleDeletePhoto = () => {
        dispatch(deleteAvatar())
    }

    return (
        <div className={!visible ? styles.modal : styles.modalActive} onClick={() => setVisible(false)}>
            <div className={styles.modalСontent} onClick={e => e.stopPropagation()}>
                <input onChange={(e) => setImage(e.target.files[0])} type="file" ref={fileRef} style={{display: "none"}}/>
                <div onClick={!image ? handleClick : handleChangeImage} className={styles.modalItem}>{image ? 'Изменить' : 'Выбрать из библиотеки'}</div>
                {/*<div className={styles.modalItem}>Сделать фото</div>*/}
                <div onClick={handleDeletePhoto} className={styles.modalItem}>Удалить текущее фото</div>
            </div>
        </div>
    );
};

export default Modal;